export default "__VITE_ASSET__CVSmjqji__"